import { useContext, useState } from "react"

//Formik
import { Form, Formik } from "formik"
import * as Yup from "yup"

// Context
import { UserContext } from "../../context/userContext"

//Styles
import refStyles from "../../styles/Referrals.module.css"

//Referral components
import { RefApiRefRatingPost } from "./ReferralsAPI"
import { LogError } from "../../helpers/logger"
import { Dialog } from "primereact/dialog"
import CustomRating from "./CustomRating"

export default function ReferralRating({
  rating,
  isLoading,
  visible,
  setRefRating,
}) {
  const userCtx = useContext(UserContext)

  const [thisRating, setThisRating] = useState(rating)

  if (!!thisRating && !thisRating.note) {
    thisRating.note = ""
  }

  const validationSchema = Yup.object().shape({
    score: Yup.number()
      .min(1, "Please select a satisfaction rating")
      .required("Please select a satisfaction rating"),
    note: Yup.string().required("Please enter a review note"),
  })

  return (
    <Dialog
      visible={visible}
      showHeader={false}
      className={refStyles.ratingModal}
    >
      <Formik
        initialValues={thisRating}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={async (values) => {
          try {
            const result = await RefApiRefRatingPost(
              userCtx.tokens.getMainToken(),
              rating.referralId,
              values,
            )

            setThisRating(result)
            setRefRating(result)
          } catch (error) {
            LogError(`Unable to submit the referral rating: `, error)
            userCtx.setNotificationError("Unable to submit the referral rating")
          }
        }}
      >
        {({ isValid, isSubmitting, dirty, values, errors }) => (
          <Form autoComplete="off">
            <div className={refStyles.ratingModalHeader}>
              <label>Participant feedback</label>
            </div>
            <div className={refStyles.ratingModalFormContainer}>
              <hr className={refStyles.ratingModalHeaderLine} />
              <CustomRating
                name={"score"}
                values={values}
                isSubmitting={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </Dialog>
  )
}
